export default {

    // Data commonly used by the app.
    app: state => {
        return state.app;
    },

    // API key of the authenticated user.
    apiKey: state => {
        return state.apiKey;
    },

    // Checklists dismissed.
    checklists: state => {
        return state.checklists || [];
    },

    // Selected task in checklist.
    task: state => {
        return state.task;
    },

    // Persistent error and success alerts.
    alerts: state => {
        return state.alerts;
    },

    // Global loading state.
    loading: state => {
        return state.loading;
    },

    // Global modal state.
    modal: state => {
        return state.modal;
    },

    // Global modal tab state.
    modalTab: state => {
        return state.modalTab;
    },

    // Global dropdown state.
    dropdown: state => {
        return state.dropdown;
    },

    // Currently expanded section title (accordion).
    expandableSection: state => {
        return state.expandableSection;
    },

    // An invite token used when signing up.
    inviteToken: state => {
        return state.inviteToken;
    },

    // The authorized user.
    user: state => {
        return state.user;
    },

    // The agency for the client portal.
    agency: state => {
        return state.agency;
    },

    // The selected project.
    project: state => {
        return state.project;
    },

    // The selected location.
    location: state => {
        let location = null;
        if (state.locationId && state.project) {
            return state.project.locations.find(l => String(l.id) === state.locationId);
        }
        return location;
    },

    // The selected location ID.
    locationId: state => {
        return state.locationId;
    },

    // Member of the selected project.
    member: state => {
        let spaceId = state.project.space_id;
        return spaceId ? state.user.members.find(m => m.space_id === spaceId) : null;
    },

    // Role of the member of the selected project.
    role: state => {
        let spaceId = state.project.space_id;
        return spaceId ? state.user.members.find(m => m.space_id === spaceId).role : null;
    },

    // If the user is a client of the selected project.
    isClient: state => {
        let spaceId = state.project.space_id;
        let role = spaceId ? state.user.members.find(m => m.space_id === spaceId).role : null;
        return role ? state.user.is_sub_account && !['owner', 'super-admin'].includes(role.slug) : false;
    },

    // The collapsed or expanded state of the sidebar.
    sidebarState: state => {
        return state.sidebarState;
    },

    // The selected language.
    lang: state => {
        return state.lang;
    },

    // First referral click.
    refFirst: state => {
        return state.refFirst;
    },

    // When the first referral link was clicked.
    refFirstAt: state => {
        return state.refFirstAt;
    },

    // Most recent referral click.
    refLast: state => {
        return state.refLast;
    },

    // When the most recent referral link was clicked.
    refLastAt: state => {
        return state.refLastAt;
    },

    // Cookie consent categories.
    consent: state => {
        return state.consent;
    },

    // Whether the cookie consent banner should be visible.
    showCookieBanner: state => {
        return state.showCookieBanner;
    },

    // Whether functional cookies have been consented to.
    hasFunctionalConsent: state => {
        return !!(state.consent && state.consent.functional === true);
    },

    // Whether analytics cookies have been consented to.
    hasAnalyticsConsent: state => {
        return !!(state.consent && state.consent.analytics === true);
    },

    // Whether the user is in dark mode.
    isDarkMode: state => {
        if (state.user?.theme === 'dark') return true;
        if (state.user?.theme === 'light') return false;
        return window.matchMedia?.('(prefers-color-scheme: dark)').matches ?? false;
    },

}